export const cssVar = (property: string) =>
  getComputedStyle(document.documentElement).getPropertyValue(property);
